const DEMO_CONTENT = /lorem ipsum|in publishing|trust\s*&\s*safety|travel credit|terms\s*&\s*privacy|what is lorem|dolor sit amet/i;
const ENGLISH_LEGAL_CONTENT = /privacy policy|terms (?:and|&) conditions|terms of service|information collection and use|your rights and choices|data deletion instructions|contact us/i;

export function isUsableStaticPage(page) {
  if (!page || !page.content || !page.metaTitle) return false;
  return !DEMO_CONTENT.test(`${page.metaTitle} ${page.content}`);
}

export function isUsableSpanishLegalPage(page) {
  return isUsableStaticPage(page)
    && !ENGLISH_LEGAL_CONTENT.test(`${page.metaTitle} ${page.content}`);
}
